import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { copySection } from 'utils/urls';

import { Forms } from 'types/forms';
import { ErrorModal } from 'types/modalTypes';

export async function postCopySection({
  id,
  accountId,
  newSectionIds,
}: TVariables): Promise<TResult> {
  const response = await fetch(copySection(accountId, id), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify([...newSectionIds]),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Forms;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  id: number;
  accountId: number;
  newSectionIds: Array<number>;
};

type TSnapshot = unknown;

function useCopySection(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { accountId, id } = params;
    const newFormsInfo = await postCopySection({
      ...params,
    });
    if (newFormsInfo.StatusCode === 200) {
      queryClient.invalidateQueries(['get_form_details', accountId, id]);
    } else if (newFormsInfo.Errors) throw newFormsInfo;

    return newFormsInfo;
  });
}

export { useCopySection };
